var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '0 50px', marginTop: '64px', zIndex: 1 })},[_c('div',{style:({ background: 'white !important', padding: '24px', minHeight: '880px' })},[_c('MigrateBarChart')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }